import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ProductGrid } from '@components/product/ProductGrid';
import type { Category, Product } from '@shared/types/product.types';

export function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [category, setCategory] = useState<(Category & { products: Product[] }) | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    fetch(`/api/categories/${slug}`)
      .then((res) => res.json())
      .then((json) => {
        setCategory(json.data);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [slug]);

  if (isLoading) {
    return <ProductGrid products={[]} isLoading />;
  }

  if (!category) {
    return (
      <div className="py-12 text-center">
        <h2 className="text-xl font-bold text-white">Category not found</h2>
        <Link to="/" className="mt-4 inline-block text-green-500 hover:text-green-400">Back to home</Link>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-8">
        <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">&larr; All Categories</Link>
        <h1 className="mt-2 text-3xl font-bold text-white">{category.name}</h1>
        {category.description && <p className="mt-2 text-gray-400">{category.description}</p>}
      </div>
      <ProductGrid products={category.products} />
    </div>
  );
}
